import React, { useState } from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { FaArrowRight, FaArrowLeft, FaMapMarkedAlt, FaShoppingCart, FaCheckCircle } from 'react-icons/fa'; // Added icons for "How It Works"
import '../style/Travel.css';

// Import images
import simienMountains from '../img/Simien Mountains - Ethiopia.jpg';
import lalibelaChurches from '../img/gonder.jpg';
import danakilDepression from '../img/Ethiopia.jpg';
import omoValley from '../img/Ethiopia travel.jpg';
import lakeTana from '../img/download (17).jpg';
import blueNileFalls from '../img/blue.jpg';

import avatar1 from '../img/41 Sleek Bun Hairstyles for Black Women_ A Style Guide - yourwifeknows_com.jpg'; 
import avatar2 from '../img/Jasper Lovell.jpg'; 
import avatar3 from '../img/download (19).jpg'; 
import vanaTourLogo from '../img/pngfind.com-carros-png-2200303.png'; 
const Slideshow = () => {
  const [scrollPosition, setScrollPosition] = useState(0); // Controls the sliding position
  const totalCards = 6; // Total number of cards
  const cardWidth = 320; // Width of each card
  const gap = 20; // Gap between the cards
  const containerWidth = totalCards * cardWidth + (totalCards - 1) * gap; // Dynamically calculate container width

  const slideLeft = () => {
    if (scrollPosition > 0) {
      setScrollPosition(scrollPosition - 1); // Move left
    }
  };

  const slideRight = () => {
    if (scrollPosition < totalCards - 1) { // Ensure we don't exceed the last card
      setScrollPosition(scrollPosition + 1); // Move right
    }
  };

  return (
    <section className="tour-section py-5">
      <Container fluid>
        <div className="row justify-content-center text-center mb-4 mb-md-5">
          <div className="col-xl-9 col-xxl-8">
            <span className="text-muted">Explore Ethiopia</span>
            <h2 className="display-5 fw-bold">Tourist Areas in Ethiopia</h2>
            <p className="lead">Discover the most stunning travel destinations with Vana Tour & Car Rental.</p>
          </div>
        </div>

        {/* Scrollable container */}
        <div
          className="cards-container"
          style={{ transform: `translateX(-${scrollPosition * cardWidth + scrollPosition * gap}px)` }} // Dynamically move cards
        >
          {/* Card items for each destination */}
          {[
            { img: simienMountains, title: "The Beauty of Simien Mountains", description: "Hike through one of the world's most breathtaking mountain ranges, home to rare wildlife." },
            { img: lalibelaChurches, title: "The Rock-Hewn Churches of Lalibela", description: "Explore the incredible rock-hewn churches, a UNESCO World Heritage site in Lalibela." },
            { img: danakilDepression, title: "The Danakil Depression", description: "Venture into one of the hottest and most unique places on Earth, the Danakil Depression." },
            { img: omoValley, title: "The Omo Valley Tribes", description: "Experience the diverse cultures of the Omo Valley and meet some of Ethiopia's most fascinating tribes." },
            { img: lakeTana, title: "Lake Tana and its Monasteries", description: "Enjoy the peaceful waters of Lake Tana and visit its ancient monasteries, steeped in history." },
            { img: blueNileFalls, title: "Blue Nile Falls", description: "Marvel at the incredible beauty of the Blue Nile Falls, one of Ethiopia's most famous natural landmarks." }
          ].map((item, index) => (
            <div className="card-item" key={index}>
              <Card className="border-0 shadow-sm">
                <img alt={item.title} className="img-fluid rounded" src={item.img} />
                <Card.Body className="px-0">
                  <a className="text-primary fw-semibold text-decoration-none" href="#">Nature and Wildlife</a>
                  <h3 className="fw-semibold my-2">
                    <a className="text-decoration-none text-dark" href="#">{item.title}</a>
                  </h3>
                  <p>{item.description}</p>
                </Card.Body>
              </Card>
            </div>
          ))}

        </div>

        {/* Controls for sliding */}
        <div className="text-center mt-4">
          <Button variant="primary" className="btn-see-more" onClick={slideLeft} aria-label="Scroll Left">
            <FaArrowLeft /> See Less
          </Button>
          <Button variant="primary" className="btn-see-more" onClick={slideRight} aria-label="Scroll Right">
            See More <FaArrowRight />
          </Button>
        </div>
      </Container>

      {/* How It Works Section */}
      <section className="how-it-works py-5">
        <Container>
          <div className="row text-center">
            <div className="col-12 mb-4">
              <span className="custom-badge text-white mb-3 d-inline-block">How It Works</span>
              <h2 className="display-5 fw-bold mb-3">Book Your Tour with Vana Tour & Car Rental</h2>
              <p className="text-muted">It's easy! Just follow these simple steps to plan your trip.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaMapMarkedAlt size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Visit Our Site</h4>
                <p className="service-text">Explore our range of destinations and tours available throughout Ethiopia.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaShoppingCart size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Choose Your Tour</h4>
                <p className="service-text">Select the destination and tour that best suits your preferences and travel style.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaCheckCircle size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Book Your Trip</h4>
                <p className="service-text">Easily book your tour and let us handle the rest for a seamless experience.</p>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section class="hero-section1">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h1>Get ready to start your exciting journey</h1>
                <p>Our agency will lead you through the amazing offers. Explore Vana's tour and car rental services today!</p>
                <a href="#" class="btn btn-primary">Book your car</a>
            </div>
        </div>
    </div>
</section>
<div className="bg-light">
  <div className="container py-5">
    <h2 className="text-center mb-5 text-primary">What Our Customers Say About Vana Tour & Car Rental</h2>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <div className="row">
          {/* First Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar1} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Tadesse Gebremedhin</h5>
                <p className="text-muted mb-0">Tourist</p>
              </div>
              <p className="lead text-center mb-0">
                "Vana’s car rental service made our trip through Ethiopia so smooth and enjoyable. The vehicles were in great condition, and the team was incredibly helpful. Highly recommend for anyone visiting!"
              </p>
            </div>
          </div>

          {/* Second Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar2} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Mariam Abebe</h5>
                <p className="text-muted mb-0">Business Owner</p>
              </div>
              <p className="lead text-center mb-0">
                "The tours offered by Vana were incredible! We explored some of the most beautiful landscapes in Ethiopia, and the guide was knowledgeable and friendly. It truly exceeded our expectations."
              </p>
            </div>
          </div>

          {/* Third Testimonial */}
          <div className="col-md-4 mb-4">
            <div className="testimonial-card p-4 p-md-5">
              <i className="bi bi-quote quote-icon position-absolute top-0 start-0 mt-3 ms-3"></i>
              <div className="text-center mb-4">
                <img src={avatar3} alt="Avatar" className="avatar mb-3" />
                <h5 className="mb-1">Hassan Mohammed</h5>
                <p className="text-muted mb-0">Corporate Client</p>
              </div>
              <p className=" lead text-center mb-0">
                "Vana’s service was exceptional! The car rental process was seamless, and the tour guides really made our experience unforgettable. I'll be using them again for my next business trip to Ethiopia."
              </p>
            </div>
          </div>
          <div className="bottom-image-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', overflow: 'hidden' }}>
  <img src={vanaTourLogo} alt="Vana Tour and Car Rental" className="bottom-image" style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
</div>
        </div>
      </div>
    </div>
  </div>
</div>

    </section>
  );
};

export default Slideshow;


